import classes from './RadioButton.module.css';

type Props = {
    checked?: boolean;
    disabled?: boolean;
};

const RadioButton = (props: Props) => (
    <div className={`${classes.radio} ${props.checked ? classes.checked : ''}`}>
        <input type="radio" checked={props.checked} readOnly disabled={props.disabled} />
    </div>
);

export default RadioButton;
